import { useState } from "react";
import { useLang } from "@/lib/lang";
import { Check } from "lucide-react";

export default function Plans({ onOpenLead }) {
  const { t } = useLang();
  const [active, setActive] = useState("m3");
  const plans = t.plans.list;
  const activePlan = plans.find((p) => p.key === active) || plans[1];

  return (
    <section id="plans" className="py-20 md:py-28" style={{ background: "var(--bg-paper)" }}>
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <div className="section-eyebrow">Diet plans</div>
            <h2 className="mt-3 font-display text-4xl md:text-5xl" style={{ color: "var(--primary)" }}>{t.plans.title}</h2>
            <p className="mt-4 text-lg" style={{ color: "var(--text-secondary)" }}>{t.plans.sub}</p>
          </div>
          <div className="inline-flex p-1.5 rounded-full" style={{ background: "var(--bg)", border: "1px solid var(--border-subtle)" }}>
            {plans.map((p) => (
              <button
                key={p.key}
                data-testid={`plan-tab-${p.key}`}
                onClick={() => setActive(p.key)}
                className="px-4 md:px-5 py-2.5 rounded-full text-sm font-semibold transition-colors"
                style={{ background: active === p.key ? "var(--primary)" : "transparent", color: active === p.key ? "white" : "var(--primary)" }}
              >
                {t.plans.tabs[p.key]}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {plans.map((p) => {
            const isActive = p.key === active;
            const isHighlight = p.highlight;
            return (
              <div
                key={p.key}
                data-testid={`plan-card-${p.key}`}
                className={`relative card-soft p-8 transition-all ${isActive ? "md:-translate-y-3" : ""}`}
                style={{
                  background: isActive ? "var(--primary)" : "var(--bg)",
                  color: isActive ? "var(--text-inverse)" : "inherit",
                  boxShadow: isActive ? "0 30px 60px -20px rgba(31,74,44,0.35)" : undefined,
                }}
              >
                {isHighlight && (
                  <div className="absolute -top-3 left-8 text-xs font-semibold uppercase tracking-widest px-3 py-1 rounded-full" style={{ background: "var(--mustard)", color: "#1A1A1A" }}>
                    {p.tag}
                  </div>
                )}
                <div className="text-sm font-semibold uppercase tracking-widest" style={{ color: isActive ? "var(--mustard)" : "var(--terracotta)" }}>{p.tag}</div>
                <h3 className="mt-2 font-display text-3xl">{p.name}</h3>
                <div className="mt-4 flex items-baseline gap-2">
                  <div className="font-display text-5xl">{p.price}</div>
                </div>
                <div className="text-sm mt-1 opacity-80">{p.price_nri}</div>
                <ul className="mt-6 space-y-3">
                  {p.features.map((f, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm">
                      <Check size={18} className="flex-shrink-0 mt-0.5" style={{ color: isActive ? "var(--mustard)" : "var(--primary)" }} />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <button
                  data-testid={`plan-cta-${p.key}`}
                  onClick={onOpenLead}
                  className="mt-8 w-full h-11 rounded-full font-semibold transition-transform hover:-translate-y-0.5"
                  style={{ background: isActive ? "var(--mustard)" : "var(--primary)", color: isActive ? "#1A1A1A" : "white" }}
                >
                  {t.plans.cta}
                </button>
              </div>
            );
          })}
        </div>

        <div className="mt-10 text-center text-sm" style={{ color: "var(--text-secondary)" }}>
          Currently viewing: <span className="font-semibold" style={{ color: "var(--primary)" }}>{activePlan.name}</span>
        </div>
      </div>
    </section>
  );
}
